import { useMutation, useQuery } from "@tanstack/react-query";
import { staticFilesApi } from "../../../modules/staticfiles/api";
import { StaticFileModule } from "../../../modules/staticfiles/enums";

export const STATIC_FILES_QUERY_KEYS = {
  initialize: (module: StaticFileModule) => ["initializeStaticFiles", module],
  reinitialize: () => ["reinitializeStaticFiles"],
};

export const useInitializeStaticFiles = (module: StaticFileModule) => {
  return useQuery({
    queryKey: STATIC_FILES_QUERY_KEYS.initialize(module),
    queryFn: async () => {
      const { data } = await staticFilesApi.initialize(module);

      return data;
    },
    staleTime: Infinity,
    gcTime: 0,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};

export const useReinitializeStaticFiles = () => {
  return useMutation({
    mutationKey: STATIC_FILES_QUERY_KEYS.reinitialize(),
    meta: { globalSpinner: false },
    mutationFn: async (module: StaticFileModule) => {
      const { data } = await staticFilesApi.initialize(module);

      return data;
    },
  });
};
